import React from "react";

// POST-DEPLOY-FIX-04 — A small red dot rendered INSIDE the input/select
// row of any required field so the user spots the requirement without
// scanning labels for asterisks. Pair it with `aria-required` on the
// underlying control for screen-reader correctness.
//
// Usage:
//   <RequiredFieldDot />               // standalone (e.g. inside label)
//   <RequiredFieldDot title="…" />     // tooltip on hover/focus
//
// We deliberately keep the dot small (8px) + bold red + ringed so it
// reads as "warning marker", not "decoration".

export const RequiredFieldDot = ({ title, className = "" }) => (
  <span
    aria-hidden="true"
    title={title}
    className={`inline-block w-2 h-2 rounded-full bg-rose-600 ring-2 ring-rose-200 ${className}`}
    data-testid="required-field-dot"
  />
);

export default RequiredFieldDot;
